export const FETCH_POLICY_LIST = "FETCH_POLICY_LIST";
export const COPY_POLICY_RULE = "COPY_POLICY_RULE";
export const DELETE_POLICY_RULE = "DELETE_POLICY_RULE";
export const CHANGE_STATUS_POLICY_RULE = "CHANGE_STATUS_POLICY_RULE";
export const CHANGE_ORDER_POLICY_RULE = "CHANGE_ORDER_POLICY_RULE";
export const LOCATION_DROPDOWN = "LOCATION_DROPDOWN";
